export default "__VITE_ASSET__389a4e17__"